<template>
  <modal name="modal-add-invoice-from-quote" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>ADD INVOICE FROM CURRENT QUOTE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="form-group">
          <label for="name">Name <span class="text-danger">*</span></label>
          <input type="text" name="name" id="name" ref="inputName"
                 :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.name">
          <div class="invalid-feedback">{{ errors.first('name') }}</div>
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea type="text" class="form-control" rows="6" v-model="postData.description" placeholder="Descrpition"></textarea>
        </div>
        <div class="pt-2 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-gray" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import ServiceInvoice from '@/services/invoice'
  import BeatLoader from 'vue-spinner/src/BeatLoader'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return {
        state: '',
        postData: false,
      }
    },
    props: ['value', 'quote'],
    watch: {
      quote: 'init',
      value ( newVal ) {
        let self = this;
        if ( newVal ) {
          self.$modal.show('modal-add-invoice-from-quote', {});
          setTimeout(() => {
            self.$refs.inputName.focus();
          }, 200);
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.resetForm();
      },
      resetForm () {
        let self = this;
        self.postData = {
          name: self.quote ? self.quote.name : '',
          client_id: self.quote ? self.quote.client_id : '',
          status: 'pending',
          quote_id: self.quote ? self.quote.id : '',
          description: '',
          fromFullQuote: true
        };
      },
      closeModal () {
        this.$modal.hide('modal-add-invoice-from-quote');
      },
      doCreate ( ) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }

        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              self.state = 'saving';
              ServiceInvoice.create(self.postData, function(invoice){
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Invoice "<strong>' + invoice.name + '</strong>" added successfully.'
                });
                self.resetForm();
                self.$emit('added', invoice);
                self.closeModal();
              },function(error){
                window.console.log(error);
                self.state = '';
              });
            }
          });
      }
    }
  }
</script>
